import React, { Component } from 'react'
import {Steps,Icon, Col, message, Spin, Select, Input, Button, Form, Row, Radio } from 'antd';
import QRCode from 'qrcode.react'
import { getAuthStatus,getSlStatus,sendSms,uploadSms,getSmsLoginStatus } from '../../../../api'
import './ewm.less'

const { Step } = Steps;

class Login extends Component {
    constructor(props) {
        super(props)
        this.getUserData = ()=> {
            getSmsLoginStatus({
                type: this.state.type
            }).then(res => {
                if (res.code === '0000') {
                    const userData = {...res.resultObj}
                    this.setState({
                        loading: false  ,
                        userData : userData,
                    })
                    if(userData.slzt != 1 && !this.state.interval && userData.status == 1 ){
                        // 每3秒检查一次状态
                       var i =  setInterval(()=>{
                            if(this.state.userData.slzt == 1){
                                clearInterval(i)
                                return ;
                            }
                            if(this.state.userData.status == 0 ){
                                return 
                            }                              
                            if(this.state.userData.status == 1){
                                const gsrzewmRes = this.state.userData.gsrzewmRes || {}
                                const rzids = this.state.type == 2 ? [gsrzewmRes.rzid, gsrzewmRes.gwRzid].filter(rzid => !!rzid) : [gsrzewmRes.rzid].filter(rzid => !!rzid)
                                if(rzids.length === 0){
                                    return
                                }
                                Promise.all(rzids.map(rzid => getSlStatus({
                                    rzid: rzid,
                                    accountId: this.state.userData.accountId,
                                    nsrsbh:  this.state.userData.nsrsbh,
                                    type : this.state.type
                                }))).then(slResults=>{
                                    if(slResults.some(slRes => slRes.resultObj == 2)){
                                        getAuthStatus({
                                            type: this.state.type
                                        }).then(res =>{
                                            if (res.code === '0000') {
                                                this.setState({
                                                    loading: false,
                                                    interval: undefined,
                                                    userData : {...res.resultObj},
                                                })
                                            }
                                        })
                                        clearInterval(i)
                                        return ;
                                    }else if (slResults.some(slRes => slRes.resultObj == 3)){
                                        // 二维码过期
                                        getAuthStatus({
                                            type: this.state.type
                                        }).then(res =>{
                                            if (res.code === '0000') {
                                                this.setState({
                                                    loading: false,
                                                    userData : {...res.resultObj},
                                                })
                                            }
                                        })
                                    }
                                })      
                            }                    
                        },5000)
                        this.setState({
                            interval: i
                        });
                        this.props.setIe(i)
                    }   
                } else {
                    message.error(res.msg)
                }
            })
        } 
        
        this.state = {
             loading: false,
             interval : undefined,
             type: 2,
             userData : {
                accountId: undefined,
                status: 0,
                slzt: 0,
                taskId: undefined, // 验证码上传id
                qrCodeRes: {
                    qrcode: "qrcode_id=zvMOpjBJZn0H57aj8TTMxx/i4PJ9Ue6y6BuAa9osPCcFAdAvmDp7i7Yobk7zzkNM&areaPrefix=4403&interfaceCode=0003",
                    qrcodeId: "3b01a82016704976be8efe593c5812f7",
                    taskId: "1813256103699238914"
                },
                gsrzewmRes: {
                    "ewm": "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",
                    "rzid": "1212"
                }
            }
        }

        this.getUserData()
    }      
    
    switchType = (e) => {
        clearInterval(this.state.interval)
        this.setState({
            type:e.target.value,
            interval : undefined
        }, this.getUserData)
        this.props.setIe(undefined)
    } 


    handleSubmit = e => {
        e.preventDefault();
        console.log(this.props.form)
        this.props.form.validateFields((err, values) => {
          if (!err) {
            if(!values.smsCode || values.smsCode == ''){
                message.error("验证码不能为空")
                return 
            }
            if (this.state.userData.taskId){
                uploadSms({
                    nsrsbh: this.state.userData.nsrsbh,
                    taskId: this.state.userData.taskId,
                    smsCode: values.smsCode
                }).then(sendSmsRes=>{
                    if(sendSmsRes.code === '0000'){
                        // 登录成功
                        this.getUserData()
                    }else{
                        message.error(sendSmsRes.msg)
                    }
                })
            }                        
          }
        })
    };

    handleSendSms = e => {
        e.preventDefault();
        if (this.state.userData.taskId){
            message.error("请不要重复获取验证码")
            return ;
        }
        this.props.form.validateFields((err, values) => {
          if (!err) {
            this.setState({
                loading: true
            })
            sendSms(values).then(sendSmsRes=>{
                if(sendSmsRes.code === '0000'){
                    this.setState({
                        loading: false  ,
                        userData : {...sendSmsRes.resultObj},
                    })
                    if(sendSmsRes.resultObj.status == 1 ){
                        // 登录成功, 不需要验证码
                        this.getUserData()
                    }
                }else{
                    this.setState({
                        loading: false 
                    })
                    message.error(sendSmsRes.msg)
                }
            })
          }
        })
    };

    render() {
        const { Option } = Select;
        const { getFieldDecorator } = this.props.form;
        const gsrzewmRes = this.state.userData.gsrzewmRes || {}
        return (
            <Spin spinning={this.state.loading}  delay={500}>
                <Steps current={!this.state.userData.status ? 0 : 1 } status={this.state.userData.slzt != 1 ? 'process':'finish' } >
                    <Step title="登录税局" description= {!this.state.userData.status ? '未登录':'已登录'} icon={!this.state.userData.status ? <Icon type="loading" /> : null} / >
                    <Step title="刷脸认证" description= {this.state.userData.slzt == 1 ? '已认证': '未认证'} icon={this.state.userData.status && this.state.userData.slzt != 1  ? <Icon type="loading" /> : null} />
                </Steps>
                    {
                        this.state.userData.status === 0 ? (
                            <Form  onSubmit={this.handleSubmit}>
                            <Form.Item label="账号" extra="居民身份证/手机号/用户名">
                              {getFieldDecorator('gryhm', {
                                rules: [
                                  {
                                    required: true,
                                    message: '请输入账号',
                                  },
                                ],
                              })(<Input />)}
                            </Form.Item>
                            <Form.Item label="密码" hasFeedback>
                              {getFieldDecorator('gryhmm', {
                                rules: [
                                  {
                                    required: true,
                                    message: '请输入密码!',
                                  }
                                ],
                              })(<Input.Password />)}
                            </Form.Item>
                            <Form.Item label="手机号">
                              {getFieldDecorator('sjhm', {
                                rules: [{ required: true, message: '请输入手机号' }],
                              })(<Input  style={{ width: '100%' }} />)}
                            </Form.Item>
                            <Form.Item label="身份类型">
                              {getFieldDecorator('sflx', {
                                rules: [{ required: true, message: '请选择身份类型' }],
                              })( <Select defaultValue="lucy" style={{ width: 120 }}>
                                <Option value="BSY">办税员</Option>
                                <Option value="GLY">管理员</Option>
                                <Option value="KPY">开票员</Option>
                              </Select>)}
                            </Form.Item>
                            <Form.Item label="验证码" extra="">
                              <Row gutter={8}>
                                <Col span={12}>
                                  {getFieldDecorator('smsCode', {
                                    rules: [{ required: false, message: '请输入验证码!' }],
                                  })(<Input />)}
                                </Col>
                                <Col span={12}>
                                  <Button disabled = {this.state.userData.taskId} onClick ={this.handleSendSms}>获取验证码</Button>
                                </Col>
                              </Row>
                            </Form.Item>
                            <Form.Item>
                              <Button type="primary" htmlType="submit">
                                登录
                              </Button>
                            </Form.Item>
                          </Form>
                        ) : null
                    }
                    {
                        this.state.userData.status == 1 ? (
                                <div className='d1'>
                                         {
                                            this.state.userData.slzt != 1 && this.state.userData.gsrzewmRes != null ?  (
                                                    <div>
                                                        <br/>
                                                        <Radio.Group value={this.state.type} buttonStyle="solid" onChange={e=>this.switchType(e)}>
                                                            <Radio.Button value="1">个税APP</Radio.Button>
                                                            <Radio.Button value="2">电子税务局/网证APP</Radio.Button>
                                                        </Radio.Group>
                                                        <br/>
                                                        <br/>
                                                        {this.state.type == 1 ? (
                                                            <div className="auth-qrcode-list">
                                                                <div className="auth-qrcode-card">
                                                                    <div className="auth-qrcode-title">个税APP</div>
                                                                    {gsrzewmRes.ewm ? <img alt="个税APP认证二维码" style={{width:'150px'}} src={'data:image/jpg;base64,' + gsrzewmRes.ewm} /> : <span>二维码生成中</span>}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <span>请使用电子税务局APP或国家网络身份认证APP扫码认证</span>
                                                                <div className="auth-qrcode-list">
                                                                    <div className="auth-qrcode-card">
                                                                        <div className="auth-qrcode-title">电子税务局APP</div>
                                                                        {gsrzewmRes.ewm ? <QRCode value={gsrzewmRes.ewm} size={150} /> : <span>二维码生成中</span>}
                                                                    </div>
                                                                    <div className="auth-qrcode-card">
                                                                        <div className="auth-qrcode-title">国家网络身份认证APP</div>
                                                                        {gsrzewmRes.gwEwm ? <QRCode value={gsrzewmRes.gwEwm} size={150} /> : <span>二维码生成中</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                     </div>
                                            ): 
                                            <div>
                                                您已完成认证，可以前往开票了！
                                            </div>
                                         }
                               
                                </div>
                        ) : null 
                    }
            </Spin>
        )
    }
}


export default Form.create({})(Login)
